import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const Ctx = createContext(null);

export function TenantProvider({ children }) {
  const { user } = useAuth();
  const [tenants, setTenants] = useState([]);
  const [tenantId, setTenantId] = useState(localStorage.getItem("cds_tenant") || null);

  useEffect(() => {
    if (!user) return;
    api.get("/tenants").then((r) => {
      setTenants(r.data);
      const stored = localStorage.getItem("cds_tenant");
      const valid = r.data.find((t) => t.id === stored);
      if (!valid && r.data[0]) {
        setTenantId(r.data[0].id);
        localStorage.setItem("cds_tenant", r.data[0].id);
      } else if (valid) {
        setTenantId(valid.id);
      }
    }).catch(() => {});
  }, [user]);

  const switchTenant = (id) => {
    setTenantId(id);
    localStorage.setItem("cds_tenant", id);
  };

  const refresh = () => api.get("/tenants").then((r) => {
    setTenants(r.data);
    if (!r.data.find((t) => t.id === tenantId) && r.data[0]) switchTenant(r.data[0].id);
  }).catch(() => {});

  const addTenant = (t, switchTo = true) => {
    setTenants((prev) => (prev.some((x) => x.id === t.id) ? prev : [...prev, t]));
    if (switchTo) switchTenant(t.id);
  };

  const current = tenants.find((t) => t.id === tenantId) || null;

  return <Ctx.Provider value={{ tenants, tenantId, current, switchTenant, addTenant, refresh }}>{children}</Ctx.Provider>;
}

export const useTenant = () => useContext(Ctx);
